
import React from "react";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";

export const SidebarHeader = () => {
  return (
    <div className="p-6">
      <div className="text-center w-full px-3 relative">
        <span className="text-6xl text-sidebar-foreground font-handwriting font-normal">Klara</span>
        <span className="text-5xl text-sidebar-primary ml-0.5 font-handwriting font-normal">.ai</span>
        
        {/* Beta Badge */}
        <div className="flex justify-center mt-2">
          <Badge 
            variant="outline" 
            className="bg-transparent text-white border-white text-xs font-medium px-3 py-1 tracking-wider"
          >
            BETA
          </Badge>
        </div>
      </div>
      
      <p className="text-sidebar-foreground/70 text-sm mt-4 mb-4 px-3">
        Arbeid & Inkluderings assistent for datadrevet arbeidsgiveroppfølging.
      </p>
      <Separator className="bg-sidebar-border" />
    </div>
  );
};
